const HWK_SPORT_TYPE = "App\\Models\\Hwk\\SportType";
const HWK_SPORT_VARIANT = "App\\Models\\Hwk\\SportVariant";

export { HWK_SPORT_TYPE, HWK_SPORT_VARIANT };
